import React from 'react'

interface MaestroIconProps {
  width?: number
  height?: number
  className?: string
}

const MaestroIcon: React.FC<MaestroIconProps> = ({
  width = 35,
  height = 24,
  className = ''
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="34"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <g transform="translate(6, 5)">
        <path
          d="M7.27148 0.223969C11.0399 0.224214 14.0947 3.31503 14.0947 7.12729C14.0945 10.9394 11.0398 14.0294 7.27148 14.0296C3.50293 14.0296 0.447444 10.9395 0.447266 7.12729C0.447266 3.31488 3.50282 0.223969 7.27148 0.223969Z"
          fill="#ED0006"
        />
        <path
          d="M16.124 0.223969C19.8925 0.224214 22.9473 3.31503 22.9473 7.12729C22.9471 10.9394 19.8924 14.0294 16.124 14.0296C12.3555 14.0296 9.29998 10.9395 9.2998 7.12729C9.2998 3.31488 12.3554 0.223969 16.124 0.223969Z"
          fill="#0099DF"
        />
        <path
          d="M11.6973 1.87497C13.1639 3.14109 14.0947 5.02358 14.0947 7.12692C14.0947 9.23004 13.1636 11.1118 11.6973 12.3779C10.2309 11.1118 9.2998 9.23001 9.2998 7.12692C9.29981 5.0236 10.2307 3.14109 11.6973 1.87497Z"
          fill="#6C6BBD"
        />
      </g>
    </svg>
  )
}

export default MaestroIcon
